import React, { useEffect } from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDanhSachThanhLy,
  updateDataSearch,
} from "../../actions/DanhSachThanhLy";
import { formatNumber } from "utils/currencyFormat";

export const TableDanhSachThanhLy = ({ quyenDaDoc }) => {
  const dispatch = useDispatch();
  const listDanhSachFull = useSelector(
    (state) => state.listDanhSachThanhLyFull
  ); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchDanhSachThanhLy); //dataSearchTaiSan dinh nghia o rootreducer

  useEffect(() => {
    dispatch(getListDanhSachThanhLy(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListDanhSachThanhLy(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListDanhSachThanhLy(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    dispatch(updateDataSearch(data));
    dispatch(getListDanhSachThanhLy(data));
    loadTaiSan();
  };
  const TotalQuantity = listDanhSachFull.TotalQuantity;

  return (
    <>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers"  style={{ position: "sticky", padding: "2px", top: "14.3rem", zIndex: "999", background:"#FFFFFF", padding:"1px 0"}}>
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />
                      <span className="color-do-bold">[ {TotalQuantity} ]</span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-9-sm">
                    <p className="text-center color7-bold">Thời gian</p>
                  </div>
                  <div className="custom-table-header flex-basis-13 flex-basis-13-sm">
                    <p className="text-center color7-bold ">Mã</p>
                  </div>
                  <div className="custom-table-header flex-basis-13 flex-basis-12-6-sm">
                    <p className="text-left color7-bold">Tên khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-18 flex-basis-16-sm">
                    <p className="text-left color7-bold">Tên tài sản</p>
                  </div>

                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-center color7-bold">Mã hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-12-8-sm">
                    <p className="text-right color7-bold">
                      Tiền thanh lý
                      <br />
                      <span className="color-do-bold">
                        {formatNumber(listDanhSachFull.TotalTienThanhLy)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-13-sm">
                    <p className="text-right color7-bold ">
                      Chêch lệch
                      <br />
                      <span className="color-cam-bold">
                        {formatNumber(listDanhSachFull.TotalTienChenhLech)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-11 flex-basis-7-6-sm">
                    <p className="tab-header text-center color7-bold">
                      Chức năng
                    </p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listDanhSachFull={listDanhSachFull.List}
                    quyenDaDoc={quyenDaDoc}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.pageIndex}
            pageSize={dataSearch.pageSize}
            totalCount={TotalQuantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
